import { Component, Input, Output, EventEmitter } from '@angular/core'

@Component ({
  selector: 'tos-modal',
  template: `
    <modal [removeVisible]="false">
      <h4>Changes to our Terms of Service</h4>
      <div class="top-buffer">
        <p>
          We've recently updated our Terms of Service. By using this application, you are agreeing to the new
          <a href="/pages/tos/{{role}}" target="_blank">Terms of Service.</a>
        </p>
      </div>
      <button class="btn btn-primary float-right" [disabled]="submitting" (click)="onSubmit()">{{!submitting ? 'Continue' : 'updating...'}}</button>
      <div class="clearfix"></div>
    </modal>
  `
})
export class TosModal {

  @Input() public role: string
  @Input() submitting: boolean = false
  @Output() submit: EventEmitter<null> = new EventEmitter<null>()

  onSubmit(): void {
    this.submitting = true
    this.submit.emit()
  }
}
